import s from "styled-components";
import { CircleButton } from "_c/button";
import Label from "_c/form/Label";

export const PriceInput = s.div`
  display: flex;
  align-items: center;
  margin-bottom: 7px;
  input {
    width: 100px;
  }
  span {
    margin: 0 10px;
  }
`;
export const GeoWrap = s.div`
  display: flex;
  align-items: center;
  ${Label} {
    margin:0;
    margin-right: 5px;
  }
`;
export const GeoTip = s(CircleButton)`
  cursor: help;
`;
